export default __webpack_public_path__ + "static/media/kr.2ac00b39.svg";